import { render, staticRenderFns } from "./OrthographNavItemsDesktop.vue?vue&type=template&id=30bc85fc&scoped=true&"
import script from "./OrthographNavItemsDesktop.vue?vue&type=script&lang=js&"
export * from "./OrthographNavItemsDesktop.vue?vue&type=script&lang=js&"
import style0 from "./OrthographNavItemsDesktop.vue?vue&type=style&index=0&id=30bc85fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bc85fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VToolbarItems})
